var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button btn--secondary back-button",attrs:{"id":"go-back"},on:{"click":_vm.goBackClick}},[_vm._v(" "+_vm._s(_vm.$t("buttons.back"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }